import { render, staticRenderFns } from "./CobrancaCliente.vue?vue&type=template&id=6533f996"
import script from "./CobrancaCliente.vue?vue&type=script&lang=js"
export * from "./CobrancaCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports